<span [class]="colorClass">{{ status }}</span>